export const UsersCollection = 'users';
export const LocationsCollection = 'locations';
export const StatsCollection = 'statsData';
export const ChecklistCollection = 'checklists';
export const AdminsCollection = 'admins';
export const KeywordsCollection = 'keywords';
export const ReviewCollection = 'reviews';
export const CheckinsCollection = 'checkins';
export const CheckinEntriesCollection = 'entries';

export const MustChecklistCollection = 'must';
export const EssentialChecklistCollection = 'essential';

export const LanguageCollection = 'languages';

export const AvgLengthReviewStatId = 'avg-count';
export const KeywordsCountStatId = 'keywords-count';
export const ReviewCountStatId = 'review-count';
export const positiveReviewsId = 'positive-count';
export const negativeReviewsId = 'negative-count';
export const monthlySummaryId = 'monthly-summary';

export const ReportsCollection = 'reports';
export const StatsCollectionOld = 'stats';
